import get from 'lodash/get'

class Video {
  constructor(rawVideo) {
    this.image = get(rawVideo, 'image', null);
    this.sourceURL = get(rawVideo, 'sourceURL', null)
    this.platformVideoId = get(rawVideo, 'platformVideoId', null);
    this.chapters = get(rawVideo, 'chapters', null)
    this.subtitleFiles = get(rawVideo, 'subtitleFiles', null)
    this.title = get(rawVideo, 'title', undefined)
    this.description = get(rawVideo, 'description', undefined)
    this.libraryId = get(rawVideo, 'libraryId', undefined)
    this.companyId = get(rawVideo, 'companyId', undefined)
    this.templateData = get(rawVideo, 'templateData', undefined)
  }

  get metaData() {
    return {
      title: this.title,
      videoId: this.platformVideoId
    };
  }

  get tracks() {
    let tracks = []
    if (!this.subtitleFiles) {
      return tracks;
    }
    this.subtitleFiles.forEach((subtitleFile, index) => {
      tracks.push({
        src: subtitleFile.blobUrl ? subtitleFile.blobUrl : subtitleFile.url,
        label: subtitleFile.name,
        kind: 'subtitles',
        default: !!subtitleFile.default,
        srclang: '',
        index: index
      });
    })
    return tracks;
  }
}

export default Video;
export {
  Video
}
